import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography, Divider, Paper, Chip, Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import ConversationApi from "Services/Conversation";

const formatDate = (v) => (v ? new Date(v).toLocaleString() : "-");
const toTitle = (v) => (v ? String(v).charAt(0).toUpperCase() + String(v).slice(1) : "-");

const ConversationViewModal = ({ openDialog, conversationId, handleClose }) => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!openDialog || !conversationId) return;
    dispatch(showLoader("Loading please wait..."));
    ConversationApi.getConversationById(conversationId).then(
      (res) => {
        dispatch(hideLoader());
        setDetails(res?.data || null);
      },
      (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Failed to fetch conversation details",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
        setDetails(null);
      }
    );
  }, [openDialog, conversationId, dispatch]);

  const messages = Array.isArray(details?.messages) ? details.messages : [];

  return (
    <Dialog open={openDialog} onClose={() => handleClose(false)} fullWidth maxWidth="md">
      <DialogTitle>Conversation Details</DialogTitle>
      <DialogContent>
        <Paper elevation={0} sx={{ p: 2, border: "1px solid #e7e7e7", borderRadius: 2, mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1.5 }}>Overview</Typography>
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Conversation ID:</strong> {details?.id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Created At:</strong> {formatDate(details?.created_at)}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Booking ID:</strong> {details?.booking_id || details?.bookings?.id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Ride ID:</strong> {details?.ride_id || details?.rides?.id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2"><strong>Booking Status:</strong></Typography>
                <Chip size="small" label={toTitle(details?.bookings?.status)} />
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2"><strong>Ride Status:</strong></Typography>
                <Chip size="small" label={toTitle(details?.rides?.status)} />
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={0} sx={{ p: 2, border: "1px solid #e7e7e7", borderRadius: 2 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
            <Typography variant="subtitle1">Messages</Typography>
            <Chip size="small" color="primary" label={messages.length} />
          </Stack>
          {messages.length === 0 && <Typography variant="body2">No messages found.</Typography>}
          {messages.map((msg, idx) => (
            <React.Fragment key={msg?.id || idx}>
              <Grid container spacing={1.2} sx={{ py: 1 }}>
                <Grid item xs={12} sm={8}><Typography variant="body2"><strong>Message:</strong> {msg?.body || "-"}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2"><strong>Sender ID:</strong> {msg?.sender_id || "-"}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2"><strong>System:</strong> {msg?.is_system_message ? "Yes" : "No"}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2"><strong>Read At:</strong> {formatDate(msg?.read_at)}</Typography></Grid>
                <Grid item xs={12} sm={4}><Typography variant="body2"><strong>Created At:</strong> {formatDate(msg?.created_at)}</Typography></Grid>
              </Grid>
              {idx < messages.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConversationViewModal;
